<template>
  <div>
    <h1>OS1 Expiring</h1>
    <v-btn @click="send" v-if="$keycloak.hasRealmRole('root')"
      >Send OS1 emails</v-btn
    >
    <v-data-table
      :headers="headers"
      :items="modifiedExpired"
      hide-actions
      class="elevation-1"
      :pagination.sync="pagination"
      :loading="loading"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <FileZ :file="props.item" />
          </td>
          <td>{{ props.item.os1date | formatDate }}</td>
          <td>{{ props.item.age }}</td>
          <td>{{ props.item.subject }}</td>
          <td>{{ props.item.detail }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="sendingEmail" persistent width="300">
      <v-card color="info" dark>
        <v-card-text>
          <span>Waiting for server to send OS1 email...</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FileZ from "@/components/link/FileZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Os1Expiring",
  metaInfo() {
    return {
      title: "OS1 Expiring",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { FileZ },
  computed: {
    modifiedExpired() {
      if (!this.expired) {
        return undefined;
      }
      return this.expired.map((e) => {
        const now = new Date();
        const os1date = new Date(e.os1date);
        const diff = now.getTime() - os1date.getTime();
        const age = Math.round(diff / (1000 * 3600 * 24));
        let subject = "OS1 expires today";
        let detail = "OS1 expires today";
        if (age > 0) {
          subject = "OS1 expired";
          detail = "OS1 expired " + age + " days ago";
        } else if (age < 0) {
          subject = "OS1 expiring soon";
          detail = "OS1 expires in " + -age + " days";
        }
        return {
          ...e,
          subject,
          detail,
          age
        };
      });
    }
  },
  data() {
    return {
      expired: [],
      headers: [
        {
          text: "Reference",
          value: "referencelong"
        },
        {
          text: "Date",
          value: "os1date"
        },
        {
          text: "Age",
          value: "age"
        },
        {
          text: "Subject",
          value: "subject"
        },
        {
          text: "Detail",
          value: "detail"
        }
      ],
      pagination: {
        sortBy: "timestamp",
        descending: false,
        page: 1,
        rowsPerPage: -1
      },
      loading: false,
      sendingEmail: false
    };
  },
  methods: {
    async fetchExpired() {
      this.loading = true;
      const response = await nbmlaw.get(`/cors/admin/file/files/os1`);
      // console.log(response.data);
      this.expired = response.data;
      this.loading = false;
    },
    async send() {
      this.sendingEmail = true;
      await nbmlaw.put(`/cors/admin/file/files/os1`, null);
      // console.log(response.data);
      this.sendingEmail = false;
    }
  },
  created() {
    this.fetchExpired();
  }
};
</script>

<style>
</style>
